import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import undoable from 'redux-undo';

import banks from "../features/banks/reducers";
import user from "../features/user/reducers/user";
import authentication from "../features/user/reducers/authentication";

// Features
import businessAccount from "../features/business_account/reducers/business_account";
import creditLimit from "../features/CreditLimit/reducers/creditLimit";
import creditLine from "../features/CreditLimit/reducers/creditLine";
import financialTrustpass from "../features/financial-trustpass/reducers";
import fcLead from "../features/CreditLimit/reducers/fc_lead";
import fcPayment from "../features/CreditLimit/reducers/fc_payment";
import opportunities from "../features/projectFinder/reducers/opportunities";
import {alerts, alertsCurrentPage, alertsTotalCount, alertsTotalPages} from "../features/alertsManager/reducers/alerts"
import opportunitiesCurrentPage from "../features/projectFinder/reducers/opportunitiesCurrentPage";
import opportunitiesTotalPages from "../features/projectFinder/reducers/opportunitiesTotalPages";
import opportunitiesTotalCount from "../features/projectFinder/reducers/opportunitiesTotalCount";

// contacts
import contacts from "../features/contacts/reducers/contactsReducer";

// company
import company from "../features/company/reducers/company";
import dataPoints from "../features/company/reducers/dataPoints";

// loans
import loans from "../features/loans/reducers/loans";
// TODO: fix in phase 7
import loanOffers from "../features/loans/reducers";
import loanPlan from "../features/loans/reducers/loanPlanReducer";

// tradeDocuments
// old: To be replaced in the future phases
import purchaseOrders from "../features/trade_documents/reducers/purchaseOrdersReducer";
import invoices from "../features/trade_documents/reducers/invoicesReducer";
import applications from '../features/trade_documents/reducers/tradeDocumentsReducer'
import tradeSupportingDocuments from "../features/supporting_documents/reducers/supportingDocuments";

// new
import tradeDocuments from "../features/trade_documents/reducers";

// trustpass
// old: To be replaced in the future phases
import personalTrustpass from "../features/trustpass/reducers/personalTrustpassReducer";
import businessTrustpass from "../features/trustpass/reducers/businessTrustpassReducer";

// new: to be updated
import trustPass from "../features/trustpass/reducers";

// notifications
import notifications from "../features/notifications/reducers";

// feedbacks
import feedbacks from "../features/feedbacks/reducers";

import shared from "../features/shared/reducers";

const rootReducer = combineReducers({
  routing: routerReducer,
  banks,
  user,
  authentication,
  company,
  dataPoints,
  businessAccount,
  personal_trustpass: personalTrustpass,
  business_trustpass: businessTrustpass,
  loan_offer: loanOffers,
  loan_plan: loanPlan,
  purchase_orders: undoable(purchaseOrders),
  invoices: undoable(invoices),
  applications: undoable(applications),
  trade_supporting_documents: tradeSupportingDocuments,
  contacts: contacts,

  // new structure reducers
  creditLimit: creditLimit,
  creditLine: creditLine,
  fc_lead: fcLead,
  fc_payment: fcPayment,
  feedbacks: feedbacks,
  financialTrustpass: financialTrustpass,
  loanOffers: loanOffers,
  loans: loans,
  notifications: notifications,
  shared: shared,
  tradeDocuments: tradeDocuments,
  trustPass: trustPass,
  opportunities: opportunities,
  alerts: alerts,

  // Opportunities Page
  opportunitiesCurrentPage: opportunitiesCurrentPage,
  opportunitiesTotalPages: opportunitiesTotalPages,
  opportunitiesTotalCount: opportunitiesTotalCount,

  // Alerts Page
  alertsCurrentPage: alertsCurrentPage,
  alertsTotalPages: alertsTotalPages,
  alertsTotalCount: alertsTotalCount,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js